import React, { useEffect, useState } from "react";
import Fontstyling from "../comman";
import { Formik } from "formik";
import * as yup from "yup";
import { Button, Form, InputGroup, Modal, Row, Col } from "react-bootstrap";
import theme from "../../../Utils/theme";
import toastFile from "../../../Service/ToastFile";

const FileUpdateModal = ({ show, selectedRow, onHide, setData }) => {
  const col = Object.keys(selectedRow);
  col.pop();
  const schemaObject = {};
  const initialValues = {};
  for (const element of col) {
    schemaObject[element] = yup
      .string()
      .required(`Please enter the ${element}`);
    initialValues[element] = selectedRow[element];
  }
  const schema = yup.object().shape(schemaObject);

  const colSubarrays = col.reduce((acc, val, index) => {
    const groupIndex = Math.floor(index / 4);
    if (!acc[groupIndex]) {
      acc[groupIndex] = [];
    }

    acc[groupIndex].push(val);
    return acc;
  }, []);

  const handleFormSubmit = (values, onSubmitProps) => {
   toastFile('update')
    setData((prev) =>
      prev.map((item, index) => {
        if (index === selectedRow.tableData.id) {
          return {
            ...values,
          };
        }
        return item;
      })
    );
    onHide();
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={Fontstyling.modalHeading}
        >
          Update Data
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={schema}
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              {colSubarrays.map((element) => {
                return (
                  <Row className="mb-3 gap-3">
                    {element.map((item) => (
                      <Form.Group as={Col} controlId={item}>
                        <Form.Label style={Fontstyling.label}>
                          {item}
                        </Form.Label>
                        <Form.Control
                          className="rounded-0 py-1"
                          style={Fontstyling.label}
                          type={
                            typeof selectedRow[item] === "string"
                              ? "text"
                              : "number"
                          }
                          placeholder={item}
                          name={item}
                          value={values[item]}
                          onChange={handleChange}
                          isInvalid={touched[item] && errors[item]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[item]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    ))}
                  </Row>
                );
              })}
              <div className="d-flex align-items-center justify-content-end gap-3">
                  <button
                    style={Fontstyling.savebutton}
                    type="submit"
                    
                  >
                    save
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    type="reset"
                    onClick={() => {
                      onHide();
                    }}
                  >
                    Cancel
                  </button>
                </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default FileUpdateModal;
